import { getTargetingDe } from '../../helpers/targeting/de/getTargetingDe';
export const configuration = {
    targeting: {
        getTargeting: getTargetingDe,
        fetchHierarchy: true,
    },
};
